/**
 * Neutral stand-in for a client headshot: a filled silhouette sized to fill
 * its circular frame, so the shoulders clip at the edge the way a real photo
 * would. Takes its colour from `currentColor`.
 */
export default function AvatarIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <circle cx="24" cy="18" r="8" />
      <ellipse cx="24" cy="47" rx="14.5" ry="14" />
    </svg>
  );
}
